import React, { useEffect, useState } from "react";
import LoanViewPage from "../../../../../entities/DashboardPage/HRModule/Loan/LoanView";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useLocation } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";
import { getBlobErrorMessage } from "../../../../../utils/blobError";

const LoanView = () => {
  const {state} = useLocation();
  const {item }=state ||{};
  const { showAlert } = useAlert();
  const role = localStorage.getItem("role");
  const [data,setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [openAddModal, setOpenAddModal] = useState(false);


  useEffect(() => {
    getLoanTransaction("","",page);
  },[page])
  const getLoanTransaction = async(text,sort,page) =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getLoanTransaction(text,sort,page,item?._id);
      if (result?.success) { 
        setData(result?.data?.loans);
        setTotal(result?.data?.total);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };


  const handleFilter = (text,sort) => {
    text ? getLoanTransaction(text):sort ? getLoanTransaction("",sort):null
  }

  const handleDownload = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.loanTransactionDownload(item?._id);
      if (!result) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const downloadError = await getBlobErrorMessage(result);
        if (downloadError) {
          LoaderHelper.loaderStatus(false);
          showAlert(downloadError, "error");
          return;
        }
        const blob = new Blob([result], { type:"application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleAddLoanPayment = async (loanId, employeeId, amount, date) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.addLoanManualPayment(loanId, employeeId, amount, date);
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message || "Loan payment added successfully", "success");
        setOpenAddModal(false);
        getLoanTransaction("","",page);
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message || "Failed to add loan payment", "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert("An error occurred while adding loan payment", "error");
    }
  };


  return (
    <LoanViewPage 
      page={page} 
      total={total} 
      handleDownload={handleDownload} 
      setPage={setPage} 
      data={data} 
      handleFilter={handleFilter}
      openAddModal={openAddModal}
      setOpenAddModal={setOpenAddModal}
      handleAddLoanPayment={handleAddLoanPayment}
      item={item}
      role={role}
    />
  )

}

export default LoanView;
